var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5999 1.42C25.8199 0.639999 24.5599 0.639999 23.7799 1.42L13.9999 11.18L4.21994 1.4C3.43994 0.619999 2.17994 0.619999 1.39994 1.4C0.619941 2.18 0.619941 3.44 1.39994 4.22L11.1799 14L1.39994 23.78C0.619941 24.56 0.619941 25.82 1.39994 26.6C2.17994 27.38 3.43994 27.38 4.21994 26.6L13.9999 16.82L23.7799 26.6C24.5599 27.38 25.8199 27.38 26.5999 26.6C27.3799 25.82 27.3799 24.56 26.5999 23.78L16.8199 14L26.5999 4.22C27.3599 3.46 27.3599 2.18 26.5999 1.42V1.42Z",
    fill: "#CF3939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.43a72716f5837cc24da4e418d5c267fc.svg";
export { ForwardRef as ReactComponent };